import { useTranslation } from "react-i18next";
import { NotificationDate } from "src/components/GlobalSearch/NotificationsItems/Link";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import NotificationIcon from "src/images/Icons/newIcons/notifications/notification.svg";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface QuestionChangedNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

export function QuestionChangedNotification({
	notification,
	removeNotification,
	className,
}: QuestionChangedNotificationProps) {
	const { openModal } = useModals();
	const { t } = useTranslation();

	const redirect = async () => {
		openModal(ModalsNames.QuestionViewModal, {
			questionId: notification.itemId,
		});
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={NotificationIcon}
			Primary={t("notifications.questionChanged.title")}
			Secondary={
				<NotificationDate status={notification.status}>
					{notification.message}
				</NotificationDate>
			}
		/>
	);
}
